$(function(){


  processingMultipleGetServerDate();

  /* PCナビ
  -------------------------------------------------------- */
  const mediaQuery = window.matchMedia('(min-width: 750px)');

  // ページが読み込まれた時に実行
  handle(mediaQuery);
  // ウィンドウサイズを変更しても実行（ブレイクポイントの監視）
  mediaQuery.addListener(handle);

  function handle(mm) {
    if (mm.matches) {
      // ウィンドウサイズ750px以上のときの処理
      $('.js-nav-dropdown').on('click',function(e){
        if($(this).hasClass('is--current')) {
          $(this).removeClass('is--current');
          $(this).next('.js-nav-dropdown-menu').removeClass('is--open');
        } else {
          $(this).addClass('is--current');
          $(this).next('.js-nav-dropdown-menu').addClass('is--open');
        }
      });
      $('.js-pv-nav-close').on('click',function(e){
        $('.js-nav-dropdown').removeClass('is--current');
        $('.js-nav-dropdown-menu').removeClass('is--open');
      });

      $('.js-pc-nav-drawer').hover(
        function() {
          $(this).addClass('is--current');
          $(this).children('.js-pc-nav-draw-menu').addClass('is--open');
        }, function() {
          $(this).removeClass('is--current');
          $(this).children('.js-pc-nav-draw-menu').removeClass('is--open');
        }
      );
    } else {
      // それ以外（モバイル）の処理
      var pos;
      $('.js-sp-nav-btn').on('click',function(e){
        e.preventDefault();
        $('.sp-nav-wrapper').addClass('is--open');
        pos = $(window).scrollTop();
        $('body').addClass('fixed').css({'top': -pos});
      });
      $('.js-sp-nav-close').on('click',function(e){
        e.preventDefault();
        $('.sp-nav-wrapper').removeClass('is--open');
        $('body').removeClass('fixed').css({'top': 0});
        window.scrollTo(0, pos);
      });

      $('.js-sp-itemsearch-btn').on('click',function(e){
        e.preventDefault();
        $('.sp-itemsearch-wrapper').addClass('is--open');
        pos = $(window).scrollTop();
        $('body').addClass('fixed').css({'top': -pos});
      });
      $('.js-sp-itemsearch-close').on('click',function(e){
        e.preventDefault();
        $('.sp-itemsearch-wrapper').removeClass('is--open');
        $('body').removeClass('fixed').css({'top': 0});
        window.scrollTo(0, pos);
      });

      $('.js-sp-nav-toggle').on('click',function(e){
        $(this).toggleClass('is--open');
        var toggleTarget = $(this).data('target');
        var elem = document.getElementById(toggleTarget);
        $(elem).slideToggle();
      });

      $('.js-sp-nav-drawer').on('click',function(e){
        $(this).closest('.js-sp-nav-draw-wrapper').addClass('is--open');
        $(this).next('.js-sp-nav-draw-menu').addClass('is--open');
        var height = $(this).next('.js-sp-nav-draw-menu').height();
        $(this).closest('.js-sp-nav-draw-container').height(height);
      });
      $('.js-sp-nav-draw-back').on('click',function(e){
        $(this).closest('.js-sp-nav-draw-wrapper').removeClass('is--open');
        $(this).closest('.js-sp-nav-draw-menu').removeClass('is--open');
        $(this).closest('.js-sp-nav-draw-container').height('auto');
      });

      $(document).on('click','.js-sp-nav-draw-menu.is--open .js-sp-nav-drawer',function(e){
        $(this).closest('.js-sp-nav-draw-menu').addClass('is--grand_open');
      });
      $(document).on('click','.js-sp-nav-draw-menu.is--open .js-sp-nav-draw-back',function(e){
        $(this).parents('.js-sp-nav-draw-menu').removeClass('is--grand_open');
      });



      $('.js-toggle').click(function() {
        $(this).toggleClass('is-active');
          if ($(this).hasClass('is-active')) {
          $('.js-togglelist').addClass('is-active');
        } else {
          $('.js-togglelist').removeClass('is-active');
        }
      });

    }
  }

  /* ページトップ
  =====================================================================*/
  var topBtn = $(".pagetop");
  topBtn.click(function () {
    $('html,body').animate({
      scrollTop: 0
    });
    return false;
  });

  /* ページ内リンク
  =====================================================================*/
  $('a[href^="#"]').click(function(){
    var speed = 10;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top - 130;
    $("html, body").animate({scrollTop:position}, speed, "swing");
    return false;
  });



  /* Tabs
  -------------------------------------------------------- */
  $('.tab-wrap .tab-btn:first-child').addClass('is-active');
  $('.tab-wrap .tab-panel:first-child').addClass('is-show');
  $('.tab-btn').click(function(){
    // クリックした要素の先祖要素の中で、classの値がgroupの要素を取得
    var group = $(this).parents('.tab-wrap');
    group.find('.is-active').removeClass('is-active');
    $(this).addClass('is-active');
    group.find('.is-show').removeClass('is-show');
    // クリックしたタブからインデックス番号を取得
    const index = $(this).index();
    // クリックしたタブと同じインデックス番号をもつコンテンツを表示
    group.find(".tab-panel").eq(index).addClass('is-show');
  });

  $('.js-panel-toggle').click(function(){
    $(this).toggleClass('is-active');
    $(this).next('.js-panel').slideToggle();
  });

});



//PC
function isPC(){
  return $(window).width() > 749;
}
// トップページか判定
function isTopPage(){
  var homeUrlPathName = '/';
  // 最後のスラッシュを消す（デモ環境対策）
  homeUrlPathName = homeUrlPathName.slice(0, homeUrlPathName.length-1);
  var regex = '^' + homeUrlPathName + '\/?$';
  return Util.isPageRegex(regex);
}

/*
 * 商品画像の矢印ボタンの処理
 */
function processingImageArrowButton(){

  //商品画像が2枚以上の場合
  if( $('.product-single__media-wrapper').length >= 2 ){
    //前へ、次へボタンを表示
    $('.product-single__media-group').prepend('<div class="customize-prev-btn"></div>');
    $('.product-single__media-group').append('<div class="customize-next-btn"></div>');

  //それ以外の場合、処理終了
  }else{
    return false;
  }

  //動作
  var activeIndex;

  //「＜」の矢印ボタンをクリックしたとき
  $(document).on("click", ".customize-prev-btn", function () {
    //カレント画像が何番目かを取得
    activeIndex = $('.active-thumb').index('.product-single__thumbnail--product-template');

    //一枚目の場合
    if( activeIndex == 0 ){
      //処理終了
      return false;
    }

    //ひとつ前の画像を表示
    //$('.product-single__thumbnail--product-template').eq(activeIndex - 1).click();
    document.getElementsByClassName("product-single__thumbnail--product-template")[activeIndex - 1].dispatchEvent(new Event('click'));


  });

  //「＞」の矢印ボタンをクリックしたとき
  $(document).on("click", ".customize-next-btn", function () {
    //カレント画像が何番目かを取得
    activeIndex = $('.active-thumb').index('.product-single__thumbnail--product-template');

    //最後の画像の場合、処理終了
  if( activeIndex == $('.product-single__thumbnail--product-template').length-1 ){
      return false;
    }

    //ひとつ後の画像を表示
    //$('.product-single__thumbnail--product-template').eq(activeIndex + 1).click();
    document.getElementsByClassName("product-single__thumbnail--product-template")[activeIndex + 1].dispatchEvent(new Event('click'));

  });

}



/*
 * アイコンの表示制御
 */
function controlProductIconDisplay(serverResponse){

  var newIconClass = '.price__badge--new';//新商品タグのclass名
  var comingIconClass = '.price__badge--comingsoon';//ComingSoonタグのclass名
  var gridItemClass = '.grid-view-item';//グリッドの各商品を括っているclass名
  var productItem;

  //新商品タグの数分処理
  for( var i=0; i<$( newIconClass ).length; i++ ){
    //各商品のDOMを取得
    $productItem = $( newIconClass ).eq(i).parents( gridItemClass );
    if( $productItem.length ){
      //新商品アイコンの表示制御
      mainControlNewProductIconDisplay( serverResponse, $productItem );
    }
  }

  //comingsoonタグの数分処理
  for( var i=0; i<$( comingIconClass ).length; i++ ){
    //各商品のDOMを取得
    $productItem = $( comingIconClass ).eq(i).parents( gridItemClass );
    if( $productItem.length ){
      //comingsoonアイコンの表示制御
      mainControlComingProductIconDisplay( serverResponse, $productItem );
    }
  }

  //Product Page
  if( $( '.template-product' ).length ){
    $productItem = $( '.product-single__meta' );
    if( $productItem.length ){
      //新商品アイコンの表示制御
      mainControlNewProductIconDisplay( serverResponse, $productItem );
      //comingsoonアイコンの表示制御
      mainControlComingProductIconDisplay( serverResponse, $productItem );
    }
  }

}

/*
 * 新商品アイコンの表示制御（メイン処理）
 */
function mainControlNewProductIconDisplay( serverResponse, $productItem ){

  var displayPeriod = 30;//新商品タグの表示期間
  var newIconClass = '.price__badge--new';//新商品タグのclass名

  //今日の日付を取得
  var today = new Date(serverResponse);

  //発売日を取得
  var releaseDateStr = $productItem.find( '.js-release_date' ).text().trim();

  if(releaseDateStr) {
    var releaseDate = new Date(releaseDateStr);
    var releaseDateEnd = new Date(releaseDateStr);

    //表示期間の最終日を計算
    releaseDateEnd.setDate(releaseDateEnd.getDate() + displayPeriod);

    //表示期間を過ぎている
    if( today.getTime() > releaseDateEnd ){
      // 新商品タグを非表示
      $productItem.find( newIconClass ).hide();
    }

    //発売日が先
    if( today.getTime() < releaseDate.getTime() ){
      // 新商品タグを非表示
      $productItem.find( newIconClass ).hide();
    }

  } else {
    $productItem.find( newIconClass ).hide();
  }

}

/*
 * ComingSoon表示制御（メイン処理）
 */
function mainControlComingProductIconDisplay( serverResponse, $productItem ){
  var comingIconClass = '.price__badge--comingsoon';//ComingSoonタグのclass名
  var cartBtnClass = '.btn-cart';

  //今日の日付を取得
  var today = new Date(serverResponse);

  //発売日を取得
  var releaseDateStr = $productItem.find( '.js-release_date' ).text().trim();

  if(releaseDateStr) {
    var releaseDate = new Date(releaseDateStr);

    // 発売開始前
    $productItem.find( comingIconClass ).hide();
    if( today.getTime() <= releaseDate.getTime() ){
      // Coming soonを表示
      $productItem.find( comingIconClass ).show();
      // 購入ボタンを非表示
      $( '.product-form__enable' ).remove();
      // 数量を非表示
      $('.quantity_selector').remove();
      // 購入できないボタンを表示
      $( '.js-release_date--disable' ).show();
    } else {
      $productItem.find( comingIconClass ).hide();
      //購入ボタンを表示
      $( '.product-form__enable' ).show();
    }
  } else {
    $productItem.find( comingIconClass ).hide();
    $( '.product-form__enable' ).show();
  }
}

/*
 * カートページ 発売開始前商品の購入制限
 */
function controlCartPurchaseReleaseDate( serverResponse ){

  var dateClass = '.js-release_date';
  var gridItemClass = '.cart__product-information';//グリッドの各商品を括っているclass名
  var productItem;

  //今日の日付を取得
  var today = new Date(serverResponse);

  //日付の設定がない場合は処理終了
  if( $( dateClass ).length < 1 ){
    return;
  }

  for( var i=0; i<$( dateClass ).length; i++ ){
    //各商品のDOMを取得
    $productItem = $( dateClass ).eq(i).parents( gridItemClass );

    //購入制御
    if( $productItem.length ){
      //発売日を取得
      var releaseDateStr = $productItem.find( dateClass ).text().trim();
      var releaseDate = new Date(releaseDateStr);


      // 発売日前なら
      if( today <= releaseDate ){
        //購入ボタンを非表示にし、購入できないボタン・メッセージを表示
        $( '.js-cart__buttons-container' ).addClass( 'cart__submit__disable' );
        $( '.cart__submit__disable--note:not(.js-release_date--message)' ).hide();
        $( '.js-release_date--message' ).show();
        // ひとつでもあれば処理終了
        return;
      // 発売後
      }else{
        //購入ボタンを表示
        $( '.cart__submit' ).show();
      }
    }
  }
}

/*
 * 現在時刻をサーバーから取得して各種処理
 */
function processingMultipleGetServerDate(){
  $.ajax({
    type : 'HEAD',
    url :  window.location.href,
    cache : false
  }).done(function(data, textStatus, xhr) {
    try {
      var serverResponse = new Date(xhr.getResponseHeader("Date"));
    } catch(e) {
      var serverResponse = new Date();
    }

    //Top page
    if( isTopPage() ){
      //新商品アイコンの表示制御
      controlProductIconDisplay(serverResponse);
    }

    //Collection Page / Search Page
    if( $( '.template-search' ).length || $( '.template-collection' ).length ){
      //新商品アイコンの表示制御
      controlProductIconDisplay(serverResponse);
    }

    //Product page / Cart page
    if( $( '.template-product' ).length > 0 || $( '.template-cart' ).length > 0 ){
      //新商品アイコンの表示制御
      controlProductIconDisplay(serverResponse);

      //発売開始前の購入制御
       controlCartPurchaseReleaseDate(serverResponse);
    }


  }).fail(function() {
    var serverResponse = new Date();
    // 失敗時の制御
  });

}